export default __webpack_public_path__ + "fa45d15afa43d242bc3ca4554ec0c73f.png";